// import CrossIcon from "Assets/Icons/CrossIcon";
import CrossIcon from "Assets/Icons/CrossIcon";
import Typography from "Components/CommonComponents/Typography";
import React, { CSSProperties } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { Button } from "reactstrap";
import "./index.css";
interface confirmationMessage {
  warningMessage: string;
  message: string;
  onConfirm: () => any;
  onCancel: () => any;
  isSuccessSweetAlert: boolean;
  warning: boolean;
  customIcon?: React.ReactNode | string;
  secondaryButtonName?: string;
  primaryButtonName?: string;
}
export declare type SweetAlertType =
  | "default"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "error"
  | "input"
  | "custom"
  | "controlled";
export interface SweetAlertOptionalProps {
  type?: SweetAlertType;
  secondary?: boolean;
  info?: boolean;
  success?: boolean;
  warning?: boolean;
  danger?: boolean;
  error?: boolean;
  input?: boolean;
  custom?: boolean;
  controlled?: boolean;
  onCancel?: () => any;
  confirmBtnText?: React.ReactNode | string;
  confirmBtnCssClass?: string;
  confirmBtnStyle?: CSSProperties;
  cancelBtnText?: React.ReactNode | string;
  cancelBtnCssClass?: string;
  cancelBtnStyle?: CSSProperties;
  btnSize?: string;
  customIcon?: React.ReactNode | string;
  placeholder?: string;
  defaultValue?: string;
  showConfirm?: boolean;
  showCancel?: boolean;
  customButtons?: any;
  timeout?: any;
  confirmBtnBsStyle: string;
  title: string;
  onConfirm: any;
  cancelBtnBsStyle: string;
  showCloseButton: any;
  secondaryButtonName?: string;
  primaryButtonName?: string;
}
const ConfirmationMessage = ({
  warningMessage,
  message,
  onCancel,
  onConfirm,
  primaryButtonName,
  secondaryButtonName,
  warning,
}: confirmationMessage) => {
  const customButton = (
    <div className="d-flex justify-content-between w-100">
      <Button
        color={primaryButtonName ? "aeslPrimary" : "aeslDeactive"}
        onClick={onConfirm}
      >
        {primaryButtonName ? primaryButtonName : "Yes,Delete"}
      </Button>
      <Button
        className={
          secondaryButtonName ? "cancelButtonSecondary" : "cancelButton"
        }
        onClick={onCancel}
      >
        {secondaryButtonName ? secondaryButtonName : "Cancel"}
      </Button>
    </div>
  );

  const componentProps: any = {
    custom: true,
    // showCloseButton: true,
    confirmBtnBsStyle: "info",
    warning: warning,
    showCancel: true,
    cancelBtnBsStyle: "light",
    onConfirm: onConfirm,
    onCancel: onCancel,
    customButtons: customButton,
    showCloseButton: false,
  };
  return (
    <SweetAlert
      {...componentProps}
      style={{
        width: "100% !important",
      }}
    >
      <div className="sweetAlertContainer">
        <div className="sweetAlertTitle">
          <div className="d-flex">
            <Typography variant="h5" color="black">
              {warningMessage}
            </Typography>
          </div>
          <div className="crossIconConfirmationBox">
            <CrossIcon onClick={onCancel} />
          </div>
        </div>

        <div className="subTitle">{message}</div>
      </div>
    </SweetAlert>
  );
};
export default ConfirmationMessage;
